module.exports = __webpack_public_path__ + "img/corrugatedBox5.26705d70.jpg";